/* The Vital Journal (sections/vh-journal-article.liquid). PROGRESSIVE ENHANCEMENT ONLY: the page is complete without it.
   1. Reading progress bar: shows the hidden [data-vhj-progress] bar, pins it just below the theme's sticky header and
      sets transform: scaleX() on its own <i>. rAF-throttled, passive listeners, no CSS custom properties written anywhere.
   2. Product shelf: shows prev/next arrows only when the rail actually overflows, and disables them at the ends. */
(function () {
  'use strict';
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function progress() {
    var bar = document.querySelector('[data-vhj-progress]');
    var art = document.querySelector('[data-vhj-article]');
    if (!bar || !art) return;
    var fill = bar.firstElementChild;
    var header = document.querySelector('.header-section');
    var queued = false, lastTop = -1, lastP = -1;
    bar.hidden = false;

    function tick() {
      queued = false;
      var top = 0;
      if (header) {
        var hb = header.getBoundingClientRect().bottom;
        top = hb > 0 ? Math.round(hb) : 0;
      }
      var r = art.getBoundingClientRect();
      var span = Math.max(1, r.height - window.innerHeight);
      var p = Math.max(0, Math.min(1, -r.top / span));
      p = Math.round(p * 1000) / 1000;
      if (top !== lastTop) { bar.style.top = top + 'px'; lastTop = top; }
      if (p !== lastP) { fill.style.transform = 'scaleX(' + p + ')'; lastP = p; }
    }
    function queue() {
      if (!queued) { queued = true; window.requestAnimationFrame(tick); }
    }
    window.addEventListener('scroll', queue, { passive: true });
    window.addEventListener('resize', queue, { passive: true });
    queue();
  }

  function shelf() {
    var rail = document.querySelector('[data-vhj-rail]');
    var nav = document.querySelector('[data-vhj-shelf-nav]');
    if (!rail || !nav) return;
    var prev = nav.querySelector('[data-dir="-1"]');
    var next = nav.querySelector('[data-dir="1"]');
    var queued = false;

    function update() {
      queued = false;
      var max = rail.scrollWidth - rail.clientWidth;
      nav.hidden = max <= 2;
      prev.disabled = rail.scrollLeft <= 2;
      next.disabled = rail.scrollLeft >= max - 2;
    }
    function queue() {
      if (!queued) { queued = true; window.requestAnimationFrame(update); }
    }
    function go(dir) {
      var card = rail.querySelector('li');
      var step = card ? card.getBoundingClientRect().width + 18 : rail.clientWidth * 0.8;
      rail.scrollBy({ left: dir * step, behavior: reduce ? 'auto' : 'smooth' });
    }
    prev.addEventListener('click', function () { go(-1); });
    next.addEventListener('click', function () { go(1); });
    rail.addEventListener('scroll', queue, { passive: true });
    window.addEventListener('resize', queue, { passive: true });
    queue();
  }

  function init() { progress(); shelf(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
